import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical, ClipboardList, ArrowUpRight } from "lucide-react";
import { BRAND } from "../lib/constants";
import CoachActivityWidget from "../components/coaching/CoachActivityWidget";

function HubTile({ to, eyebrow, title, description, icon: Icon, accent, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group relative flex flex-col bg-white border border-[var(--tir-ink)] hover:border-[var(--tir-burgundy)] transition-colors overflow-hidden"
    >
      <div
        className="absolute top-0 left-0 h-1 w-full"
        style={{ backgroundColor: accent }}
      />
      <div className="p-8 lg:p-10 flex-1 flex flex-col">
        <div className="flex items-start justify-between mb-6">
          <div
            className="h-14 w-14 border border-[var(--tir-ink)] flex items-center justify-center group-hover:bg-[var(--tir-burgundy)] group-hover:border-[var(--tir-burgundy)] group-hover:text-white transition-colors"
            style={{ color: accent }}
          >
            <Icon size={26} strokeWidth={1.3} />
          </div>
          <ArrowUpRight
            size={28}
            className="text-[var(--tir-muted)] group-hover:text-[var(--tir-burgundy)] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
          />
        </div>
        <div
          className="font-eyebrow text-[11px] tracking-[0.3em] uppercase font-semibold mb-3"
          style={{ color: accent }}
        >
          {eyebrow}
        </div>
        <div className="font-serif-display text-4xl lg:text-5xl text-[var(--tir-ink)] leading-[1.05] mb-4">
          {title}
        </div>
        <p className="text-sm text-[var(--tir-muted)] leading-relaxed">
          {description}
        </p>
      </div>
    </Link>
  );
}

export default function LandingPage() {
  return (
    <div
      className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24"
      data-testid="landing-page"
    >
      <section className="max-w-3xl mb-16 lg:mb-20">
        <div className="font-eyebrow text-[11px] tracking-[0.3em] uppercase text-[var(--tir-burgundy)] font-semibold mb-4">
          {BRAND.name} · Studio
        </div>
        <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.03] text-[var(--tir-ink)]">
          Welcome back, Coach.
        </h1>
        <p className="text-base text-[var(--tir-muted)] mt-6 leading-relaxed max-w-2xl">
          Your private workspace for lactate profiling and coaching programs — branded,
          print-ready, and built around how you actually work with runners.
        </p>
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        <HubTile
          to="/lactate"
          eyebrow="Hub 01"
          title="Lactate Testing"
          description="Log lactate tests, chart LT1 and LT2, prescribe training zones, and send print-ready reports to your athletes."
          icon={FlaskConical}
          accent="#7A1F2B"
          testId="hub-lactate"
        />
        <HubTile
          to="/coaching"
          eyebrow="Hub 02"
          title="Coaching Programs"
          description="Build 1-on-1 weekly plans or library programs. Drag-and-drop workouts, editable intros, and branded PDFs ready to send."
          icon={ClipboardList}
          accent="#1C1917"
          testId="hub-coaching"
        />
      </section>

      <div className="mt-10 grid grid-cols-1 gap-6">
        <CoachActivityWidget />
      </div>

      <section className="mt-20 border-t border-[var(--tir-border)] pt-8 font-eyebrow text-xs tracking-[0.25em] uppercase text-[var(--tir-muted)] flex items-center justify-between">
        <span>{BRAND.website}</span>
        <span>Signed in · Private studio</span>
      </section>
    </div>
  );
}
